import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Form, Image, Input, Modal, Row, message } from 'antd';
import React, { useRef, useState } from 'react';
import { Images } from '../../../../controller/Images';
import { CopyOutlined } from '@ant-design/icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { createInvitation } from '../../../../controller/api/invitationServices';
import { getAdminDetail } from '../../../../controller/localStroageHandler';
import { to } from '@react-spring/web';

const ShareTestModal = ({ textLink, setTestLink, testId, setTestID }) => {
  const [url, setUrl] = useState(null);
  const [otp, setOtp] = useState(null);
  const textRef = useRef(null);
  const otpRef = useRef(null);
  const userDetail = getAdminDetail();
  // const handleCopy = () => {
  //   if (textRef.current) {
  //     const textToCopy = textRef.current.textContent;
  //     navigator.clipboard
  //       .writeText(textToCopy)
  //       .then(() => {
  //         message.success('Text copied!');
  //       })
  //       .catch((error) => {
  //         console.error('Failed to copy text: ', error);
  //       });
  //   }
  // };
  const handleCopy = () => {
    if (textRef.current) {
      const textToCopy = textRef.current.textContent;
  
      // Check if the Clipboard API is available
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            message.success('Text copied!');
          })
          .catch((error) => {
            console.error('Failed to copy text: ', error);
          });
      } else {
        // Fallback: create a temporary textarea and execute copy command
        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        message.success('Text copied!');
      }
    }
  };

  const handleInvite = (val) => {
    setUrl(null);
    setOtp(null);
    const payload = {
      email: val?.email.toLowerCase(),
      testID: testId,
      test_link: window?.location?.origin,
    };
    createInvitation(payload,{id:userDetail?.organization_id?._id})
      .then((res) => {
        setOtp(res?.data?.data?.otp);
        setUrl(res?.data?.data?.testLink);
        message.success(res?.data?.message);
      })
      .catch((err) => message.info(err?.response?.data?.message));
  }
  // const handleOtpCopy = () => {
  //   if (otpRef.current) {
  //     const otpToCopy = otpRef.current.textContent;
  //     navigator.clipboard
  //       .writeText(otpToCopy)
  //       .then(() => {
  //         message.success('OTP copied!');
  //       })
  //       .catch((error) => {
  //         console.error('Failed to copy OTP: ', error);
  //       });
  //   }
  // };
  const handleOtpCopy = () => {
    if (otpRef.current) {
      const otpToCopy = otpRef.current.textContent;
  
      // Check if the Clipboard API is available
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(otpToCopy)
          .then(() => {
            message.success('OTP copied!');
          })
          .catch((error) => {
            console.error('Failed to copy OTP: ', error);
          });
      } else {
        // Fallback: create a temporary textarea and execute copy command
        const textarea = document.createElement('textarea');
        textarea.value = otpToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        message.success('OTP copied!');
      }
    }
  };
  return (
    <Modal title='' open={textLink} closeIcon={null} footer={null} width={350}>
      <div className='d-flex flex-column justify-content-center align-items-center text-center pt-4 gap-3'>
        <div className='d-flex flex-column'>
          <span className='fs-4 fw-semibold'>Share Test</span>
          <p className='fs-6 opacity-50'>Copy the link Below to share</p>
        </div>
        <div className='bg-white border border-color p-1 w-100 d-flex justify-content-between align-items-center rounded-1'>
          <span
            ref={textRef}
            className='text-truncate test-link prevent-select text-muted fw-medium'
            style={{ maxWidth: '200px', height: '27px' }}
          >
            {url}
          </span>{' '}
          <CopyOutlined
            className={`${url == null ? 'disabled' : 'text-color-custom'}`}
            onClick={() => handleCopy()}
          />
        </div>
        {otp != null&&<div className='w-100 d-flex gap-2 align-items-center'>
          <span className='fs-6 fw-medium'>OTP :</span>
          <div className='bg-white border border-color p-1 d-flex justify-content-between align-items-center rounded-1 gap-2'>
            <span
              ref={otpRef}
              className='text-truncate test-link prevent-select text-muted fw-medium'
              style={{ maxWidth: '80px', height: '27px' }}
            >
              {otp || '-'}
            </span>{' '}
            {otp != null && (
              <CopyOutlined
                className={`text-color-custom`}
                onClick={() => handleOtpCopy()}
              />
            )}
          </div>
        </div>}
        <div className='w-100 text-start'>
          <Form onFinish={(val) => handleInvite(val)}>
            <span className='fs-6 fw-semibold'>Email</span>
            <Row gutter={[12, 12]}>
              <Col span={18}>
                <Form.Item
                  name='email'
                  rules={[
                    {
                      required: true,
                      message: 'Plese enter the Email',
                    },
                    {
                      pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
                      message: 'Enter the valid email',
                    },
                  ]}
                >
                  <Input
                    className='w-100 bg-light'
                    placeholder='Enter Email address'
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Button
                    type='primary'
                    htmlType='submit'
                    className='w-100 fs-6 fw-normal btn-border-color d-flex justify-content-center align-items-center button-color custom-hover-btn'
                  >
                    Invite
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <Row className='w-100' gutter={[12, 12]}>
          <Col span={12}>
            <Button
              type='text'
              className={`w-100 text-color-custom fs-6 fw-semibold d-flex justify-content-center align-items-center ${
                url != null && 'custom-hover-btn'
              } gap-2`}
              onClick={() => handleCopy()}
              disabled={url != null ? false : true}
            >
              <FontAwesomeIcon icon={faLink} />
              Copy Link
            </Button>
          </Col>
          <Col span={12}>
            <Button
              type='default'
              className='text-color-custom w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
              onClick={() => {
                setTestLink(false);
              }}
            >
              Done
            </Button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default ShareTestModal;
